import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type YamarketProductSettings as SchemaYamarketProductSettings } from '../schemas/YamarketProductSettings';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 */
export const GetYandexMarketProductsSettingsContentType = '' as const;
export type GetYandexMarketProductsSettingsRequest = void;
export type GetYandexMarketProductsSettingsResponses = LinkCommonErrorResponses & {
    '200': {
        'application/json': SchemaYamarketProductSettings;
    };
};
export type GetYandexMarketProductsSettingsResponseSuccess =
    GetYandexMarketProductsSettingsResponses['200']['application/json'];
export type GetYandexMarketProductsSettingsSearchParams = undefined;
export type GetYandexMarketProductsSettingsPathParameters = undefined;
export const GetYandexMarketProductsSettingsUrl = '/integrations/settings/products/yamarket' as const;
export const GetYandexMarketProductsSettingsMethod = 'GET' as const;
export const getGetYandexMarketProductsSettingsUrl = (_params?: GetYandexMarketProductsSettingsPathParameters) =>
    GetYandexMarketProductsSettingsUrl;
